var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBridge32Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "23-super star",
    id: "_23-super_star"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 32
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 36
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 28
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 24
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 20,
    y: 4
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 16,
    y: 4
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 44,
    y: 4
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 40,
    y: 4
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 32,
    y: 60
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 36,
    y: 60
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 28,
    y: 60
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 24,
    y: 60
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 20,
    y: 56
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 16,
    y: 56
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 44,
    y: 56
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 40,
    y: 56
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    transform: "translate(96 -28) rotate(90)",
    width: 4,
    x: 60,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    transform: "translate(100 -24) rotate(90)",
    width: 4,
    x: 60,
    y: 36
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    transform: "translate(92 -32) rotate(90)",
    width: 4,
    x: 60,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    transform: "translate(88 -36) rotate(90)",
    width: 4,
    x: 60,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    transform: "translate(80 -36) rotate(90)",
    width: 4,
    x: 56,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    transform: "translate(76 -40) rotate(90)",
    width: 4,
    x: 56,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    transform: "translate(104 -12) rotate(90)",
    width: 4,
    x: 56,
    y: 44
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    transform: "translate(100 -16) rotate(90)",
    width: 4,
    x: 56,
    y: 40
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    transform: "translate(36 32) rotate(90)",
    width: 4,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    transform: "translate(40 36) rotate(90)",
    width: 4,
    y: 36
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    transform: "translate(32 28) rotate(90)",
    width: 4,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    transform: "translate(28 24) rotate(90)",
    width: 4,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    transform: "translate(28 16) rotate(90)",
    width: 4,
    x: 4,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    transform: "translate(24 12) rotate(90)",
    width: 4,
    x: 4,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    transform: "translate(52 40) rotate(90)",
    width: 4,
    x: 4,
    y: 44
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    transform: "translate(48 36) rotate(90)",
    width: 4,
    x: 4,
    y: 40
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 12,
    y: 8
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 48,
    y: 8
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 8,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 8,
    y: 48
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 12,
    y: 52
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 48,
    y: 52
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 52,
    y: 48
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 52,
    y: 12
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 16,
    y: 40
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 44,
    y: 40
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 20,
    y: 44
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 40,
    y: 44
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 24,
    y: 48
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 28,
    y: 48
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 32,
    y: 48
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 36,
    y: 48
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 16,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 16,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 12,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 16,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 8,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 12,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 20,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 24,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 20,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 16,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 24,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 8,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 12,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 20,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 44,
    y: 16
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 44,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 40,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 44,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 36,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 40,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 48,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 52,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 48,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 44,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 52,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 36,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 40,
    y: 20
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 4,
    x: 48,
    y: 20
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBridge32Px);
export default __webpack_public_path__ + "static/media/icon_bridge_32px.9fa573ddcda1ddb1e1911511f04b7e11.svg";
export { ForwardRef as ReactComponent };